import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputMask = _resolveComponent("InputMask")!

  return (_openBlock(), _createBlock(_component_InputMask, {
    name: _ctx.name,
    type: "text",
    class: _normalizeClass(["form-control h-auto time-input", {
            invalid: _ctx.invalid
        }]),
    mask: "99:99",
    placeholder: _ctx.placeholder,
    autoClear: false,
    input: _ctx.validateDate(),
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.value) = $event)),
    onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', _ctx.value != '__:__' ? _ctx.value.replaceAll('_', '0') : '')))
  }, null, 8, ["name", "class", "placeholder", "input", "modelValue"]))
}